import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import {
  AIRPORT_API_PATH,
  FLIGHT_SEARCH_SETUP,
} from "../constants/apiEndPoints";

class AirportService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public get(params: string): Promise<ICoreResponse> {
    return this.restClient.get(AIRPORT_API_PATH.GET + `?query=${params}`);
  }

  public getFlightSearchSetupDetails(
    organizationId?: string,
  ): Promise<ICoreResponse> {
    const url = organizationId
      ? `${FLIGHT_SEARCH_SETUP.GET}?organization_id=${organizationId}`
      : FLIGHT_SEARCH_SETUP.GET;

    return this.restClient.get(url);
  }
}

export default AirportService;
